/**
 * Route for `custom-quote-pricing-post-starter`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomQuotePricingPostStarterPage } from "../features/custom-quote-pricing-post-starter/CustomQuotePricingPostStarterPage";

export const customQuotePricingPostStarterRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-quote-pricing-post-starter",
	component: CustomQuotePricingPostStarterPage,
});

export default customQuotePricingPostStarterRoute;
